<div class="flex-m flex-s flex-column-reverse-m flex-column-reverse-s">
</div>

<div class="flex">
    <action class="button p-r-0-s p-l-0-s p-r-0-m p-l-0-m flex-grow"
            [class.is-disabled]="isDisabled"
            [status]="status"
            (click)="submit()"
            cy-basketAddButton>
        {{ buttonCopy }}
    </action>
</div>
<result class="block"
        [status]="status"></result>